import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-warehouse",
  "use": "icon-warehouse-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-warehouse\"><path d=\"M504 90.608L96 303.472V912h80V351.968l328-171.136L832 351.968V912h80V303.472L504 90.608zM288 912h432V464H288v448z m80-368h96v64h80v-64h96v288h-96v-64h-80v64h-96V544z\" fill=\"#94948d\" p-id=\"6079\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol